export const API_BASE_URL = 'https://48fxocpfuf.execute-api.us-east-1.amazonaws.com/production';
